import { takeLatest, put, call } from 'redux-saga/effects';
import api from 'api/client';
import * as product from 'reducer/rProduct';

export function* sProduct() {
    yield takeLatest(product.fetchProductListRequest, fetchProductList);
}

function* fetchProductList(action) {
    try {
        const response = yield call(() =>
            // 제품 이름은 라이선스 파일에 실리는 값이라 발급 서버가 소유자다.
            // 포탈이 자기 목록을 갖고 있으면 화면 표기와 파일 내용이 어긋날 수 있다.
            api.get('/partners/products')
        );

        if (response.data.resultCode === "0000") {
            yield put(product.fetchProductListSuccess({ data: response.data.data }));
        } else {
            yield put(product.fetchProductListFailure());
        }
    } catch (error) {
        yield put(product.fetchProductListFailure());
    } finally {
        yield put(product.setLoading(false));
    }
}